export default "__VITE_ASSET__6b93a22f__"